import { enqueueSnackbar, OptionsWithExtraProps, SnackbarMessage, VariantType } from 'notistack'

export const toast = (message: SnackbarMessage, options?: OptionsWithExtraProps<VariantType>) => {
  const mergedOptions = {
    ...options,
    SnackbarProps: {
      ...(options?.SnackbarProps || {}),
      'aria-label': message?.toString(),
      role: 'alert',
    },
  }

  return enqueueSnackbar(message, mergedOptions)
}
